import { FC } from "react";
import { IOption } from "../../interfaces/Utils";

interface IEnumField {
  data: string | number;
  options: IOption[];
}

const EnumField: FC<IEnumField> = ({ data, options }) => {
  const record: any = options.find((option) => option.value === data);

  return <div>{record?.label} </div>;
};

export default EnumField;
